import { http } from "@api/base";
import _has from "lodash/has";

const userURL = "/me";
const usersURL = "/users";

const get = async () => {
  const res = await http.get(userURL);
  if (_has(res, "data.id")) {
    res.data.id = res.data.id.toString();
  }
  return res;
};

const update = async (userData) => {
  const res = await http.put(userURL, userData);
  if (_has(res, "data.id")) {
    res.data.id = res.data.id.toString();
  }
  return res;
};

// Get user profile by ID
const getUserProfileById = async (userId) => {
  const res = await http.get(`${usersURL}/${userId}/profile`);
  if (_has(res, "data.id")) {
    res.data.id = res.data.id.toString();
  }
  return res;
};

// Get user profile by username
const getUserProfileByUsername = async (username) => {
  const res = await http.get(
    `${usersURL}/username/${encodeURIComponent(username)}/profile`
  );
  if (_has(res, "data.id")) {
    res.data.id = res.data.id.toString();
  }
  return res;
};

// Batch fetch user profiles
const getBatchUserProfiles = async (userIds) => {
  try {
    const res = await http.post(`${usersURL}/batch-profiles`, {
      user_ids: userIds,
    });
    return res;
  } catch (error) {
    const users = await Promise.allSettled(
      userIds.map((id) => getUserProfileById(id))
    );

    const profiles = {};
    const errors = {};

    users.forEach((result, index) => {
      const userId = userIds[index];
      if (result.status === "fulfilled") {
        profiles[userId] = result.value.data;
      } else {
        errors[userId] = result.reason?.message || "Unknown error";
      }
    });

    return {
      data: {
        profiles,
        errors,
        total_requested: userIds.length,
        total_found: Object.keys(profiles).length,
      },
    };
  }
};

const getUserById = async (userId) => {
  return getUserProfileById(userId);
};

const loans = (documentPid) => {
  const loansURL = "/loans";
  return http.get(`${userURL}${loansURL}?document_pid=${documentPid}`);
};

// Exported API object (deduplicated)
export const userApi = {
  get,
  update,
  getUserById,
  getUserProfileById,
  getUserProfileByUsername,
  getBatchUserProfiles,
  loans,
};
